import React, { FC } from 'react';
import { AllieText } from '../../../../../components';
import { AllieLinkBrokenIcon } from '../../../../..';
import {
  ChainIconContainer,
  StyledSuspendedLineContainer,
  StyledTitleText,
} from './SuspendedLine.styles';

interface SuspendedLineProps {
  title?: string;
  subtitle?: string;
  lastUpdate?: string;
  isCard?: boolean;
}

export const SuspendedLine: FC<SuspendedLineProps> = ({
  title,
  subtitle,
  lastUpdate,
  isCard = false,
}) => {
  return (
    <StyledSuspendedLineContainer isCard={isCard}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <ChainIconContainer color="neutral-70">
          <AllieLinkBrokenIcon display="flex" />
        </ChainIconContainer>
        {title && <StyledTitleText type="h5">{title}</StyledTitleText>}
        {subtitle && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <AllieText type="body3" color="neutral-60">
              {subtitle}
            </AllieText>
          </div>
        )}
      </div>
      {lastUpdate && (
        <AllieText type="body3" color="neutral-60">
          {lastUpdate}
        </AllieText>
      )}
    </StyledSuspendedLineContainer>
  );
};
